import Chip from '@mui/material/Chip'
import type { ChipOwnProps } from '@mui/material/Chip'
import type { QuestionGenerationStatus } from '../types/models'

const LABELS: Record<QuestionGenerationStatus, string> = {
  NONE: 'No questions',
  PENDING: 'Pending',
  IN_PROGRESS: 'Generating…',
  COMPLETED: 'Ready',
  FAILED: 'Failed',
}

const CHIP_COLORS: Record<QuestionGenerationStatus, ChipOwnProps['color']> = {
  NONE: 'default',
  PENDING: 'warning',
  IN_PROGRESS: 'info',
  COMPLETED: 'success',
  FAILED: 'error',
}

export default function GenerationStatusBadge({ status }: { status: QuestionGenerationStatus }) {
  return <Chip label={LABELS[status]} color={CHIP_COLORS[status]} size="small" />
}
